/* eslint-disable no-unused-vars */
import { useHistory, useLocation } from "react-router-dom";
import WhatsappConnectionsPage from "../Whatsapp/WhatsappConnectionsPage";
import React, { useState } from "react";
import { connect } from "react-redux";
import iconAdjustments from "../../../../assets/icons/adjustments.svg";
import TabsParametrizacao from "../../../../partials/TabsParametrizacao";
import Loading from "../../../home/components/Loading";
import { ConfigProjudi } from "../ConfigProjudi";
import AutomaticResponseView from "./Components/AutomaticResponses/AutomaticResponseView";
import { ChatGptParams } from "./Components/ChatGpt";
import DocumentCategoryView from "./Components/DocumentCategoryView/DocumentCategoryView";
import { ProcessualView } from "./Components/Processual";

const ParametrizacaoListing = (props) => {
  window.setPageTitle("Parametrizações - Admin");

  const DOCUMENTOS_TAB = "DOCUMENTOS";
  const ACOES_TAB = "AÇŌES";
  const CONFIG_PROJUDI_TAB = "CONFIGURAÇÕES";
  const AUTOMATIC_RESPONSES = "RESPOSTAS";
  const CHAT_GPT = "DONNA";
  const WHATSAPP_TAB = "WHATSAPP";
  const location = useLocation();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [titles, setTitles] = useState([
    DOCUMENTOS_TAB,
    ACOES_TAB,
    AUTOMATIC_RESPONSES,
    CHAT_GPT,
    CONFIG_PROJUDI_TAB,
    WHATSAPP_TAB,
  ]);

  const getIndexFromAdminTab = (tabTitle) => {
    return titles.findIndex((title) => title === tabTitle);
  };

  return (
    <>
      <div id="scrollTop"></div>
      <Loading isLoading={loading} />
      <TabsParametrizacao
        initialTab={new URLSearchParams(location.search).get("aba") === "whatsapp" && props.user?.role === "ADMIN" ? getIndexFromAdminTab(WHATSAPP_TAB) : undefined}
        onTabChange={(index) => {
          const query = new URLSearchParams(location.search);
          if (titles[index] === WHATSAPP_TAB) query.set("aba", "whatsapp");
          else query.delete("aba");
          history.replace({ pathname: location.pathname, search: query.toString() });
        }}
        title="Parametrizações"
        icon={iconAdjustments}
        titles={titles}
        contents={[
          <DocumentCategoryView />,
          <ProcessualView />,
          <AutomaticResponseView />,
          <ChatGptParams />,
          <ConfigProjudi />,
          <WhatsappConnectionsPage embedded />,
        ]}
        adminTabs={{ index: [getIndexFromAdminTab(CONFIG_PROJUDI_TAB), getIndexFromAdminTab(WHATSAPP_TAB)] }}
      />
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(ParametrizacaoListing);
